import type { SingleHero } from '@mybonus/public';

import { useDevice } from '../../hooks';
import { Box } from '../../primitives';
import { mainTheme, invertTheme, ThemeProvider } from '../../theme';
import {
	$CoverSection,
	Headline,
	Description,
	Content,
	Wrapper,
	Button,
	HeroAnchor,
} from './Hero.parts';

export type HeroProps = {
	hero: SingleHero;
};

export function Hero(props: HeroProps) {
	const { headline, description, theme: preferredTheme, coverUrl, link } = props.hero;
	const device = useDevice();
	const heroContent = (
		<Wrapper>
			<Content>
				{headline && <Headline>{headline}</Headline>}
				{description && <Description>{description}</Description>}
				{link?.label && (
					<Box>
						<Button text={link.label} to={{ local: link.url }} />
					</Box>
				)}
			</Content>
		</Wrapper>
	);
	const clickableHeroUrl = link?.url && !link.label ? link.url : null;

	console.log({ clickableHeroUrl, link });

	return (
		<$CoverSection
			backgroundImageUrl={(device.min('laptop') ? coverUrl.desktop : coverUrl.mobile) || undefined}
		>
			<ThemeProvider theme={preferredTheme === 'invert' ? invertTheme : mainTheme}>
				{clickableHeroUrl ? (
					<HeroAnchor to={{ url: clickableHeroUrl }} underlined={false}>
						{heroContent}
					</HeroAnchor>
				) : (
					heroContent
				)}
			</ThemeProvider>
		</$CoverSection>
	);
}
